export default {
      id: "dots-usage",
      viewBox: "0 0 16 4",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#dots",
      toString: function () {
        return this.url;
      }
    }